import * as z from "zod/v4";

export const setCustomReturnIntegration = {
  name: "setCustomReturnIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};

export const getCustomReturnIntegration = {
  name: "getCustomReturnIntegration" as const,
  input: z.object({}),
  output: z.object({
    customReturnIntegration: z.optional(z.object({ enabled: z.boolean() })),
  }),
};

export type GetCustomReturnIntegrationOutput = z.infer<
  typeof getCustomReturnIntegration.output
>;

export const disconnectCustomReturnIntegration = {
  name: "disconnectCustomReturnIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
